// extracted by mini-css-extract-plugin
export default {"foldout":"hGGINXAtqB3HI9FZuflq","foldout_content":"opUHU0iFZ9E_EtKwJ3Wo","foldout__open":"lGVfvUxu9yVI8i_XIGch"};